export default __webpack_public_path__ + "static/media/1920 cutlery side.5e5e335a.png";